import {
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { StickyBottomBarPortalService } from '../services/sticky-bottom-bar-portal.service';

/**
 * Marks the DOM slot where `umssStickyBottomBar` elements will be teleported.
 *
 * Apply once in the layout template:
 * ```html
 * <div umssStickyBottomBarOutlet></div>
 * ```
 *
 * Uses `display: contents` so the element itself is invisible to flex/grid
 * layout — teleported children behave as direct children of the parent
 * flex container.
 */
@Directive({
  selector: '[umssStickyBottomBarOutlet]',
  standalone: true,
  host: { '[style.display]': '"contents"' }
})
export class UmssStickyBottomBarOutletDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private service = inject(StickyBottomBarPortalService);

  ngOnInit(): void {
    this.service.registerOutlet(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.service.unregisterOutlet();
  }
}
